import { type FC, type HTMLAttributes } from 'react'
import { FormattedMessage } from 'react-intl'
import { Typography } from '@mui/material'
import { useTheme } from '@mui/material/styles'

import * as styles from './styles'

type AutocompleteNoResultsGenericMessageProps = {
  inputValue: string
}

const AutocompleteNoResults: FC<AutocompleteNoResultsGenericMessageProps & HTMLAttributes<HTMLDivElement>> = ({
  inputValue,
  ...rest
}) => {
  const theme = useTheme()

  return (
    <div {...rest} css={styles.noResultText(theme)}>
      <Typography css={styles.noResultTitle(theme)} color="textPrimary" variant="h3">
        <FormattedMessage id="search_no_results_title" values={{ input: inputValue }} />
      </Typography>
      <Typography color="textSecondary">
        <FormattedMessage id="search_no_results_body" />
      </Typography>
    </div>
  )
}

export default AutocompleteNoResults
